import strings from "./strings";
import login from "./login";
import lesson from "./lesson";
import shop from "./shop";
import donate from "./donate";
import tournaments from "./tournaments";
import managers from "./managers";
import soap from "./soap";
import masterclass from "./masterclass";
import profile from "./profile";
import lists from "./lists";

export default {
    strings:strings,
    login:login,
    lesson:lesson,
    shop:shop,
    donate:donate,
    tournaments:tournaments,
    managers:managers,
    soap:soap,
    masterclass:masterclass,
    profile:profile,
    lists:lists
};